/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q14Inputs */

const et_faq_q14 = /** @type {(inputs: Faq_Q14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas mõõta, kas koduleht ja SEO tegelikult raha teenivad?`)
};

const en_faq_q14 = /** @type {(inputs: Faq_Q14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I measure whether my website and SEO are actually generating revenue?`)
};

/**
* | output |
* | --- |
* | "How do I measure whether my website and SEO are actually generating revenue?" |
*
* @param {Faq_Q14Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q14 = /** @type {((inputs?: Faq_Q14Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q14Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q14(inputs)
	return en_faq_q14(inputs)
});